// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  background-color: #F2F2F4;
}
:host app-map {
  display: block;
  margin-bottom: 32px;
}
:host app-map ::ng-deep .teams, :host app-map ::ng-deep .mapFooter {
  max-width: 1200px;
  margin: 0 auto 30px;
}
:host app-stats {
  margin-top: 32px;
}
:host app-stats ::ng-deep .badgesWrapper {
  max-width: 1200px;
  width: 100%;
}
:host app-stats ::ng-deep .summaryWrapper {
  max-width: 1200px;
}
:host .loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
:host .loader-overlay p {
  font-size: 24px;
  line-height: 28px;
  padding: 12px 24px;
  color: #C9CBD1;
  border-radius: 24px;
  background: rgba(26, 30, 41, 0.9);
}
:host .loader-overlay.show svg, :host .loader-overlay.show svg path {
  animation-play-state: running;
}
:host .banner ::ng-deep iframe {
  display: block;
  margin: 0 auto;
}
:host #div-banner_superior {
  background: #0D0D0D;
  margin-bottom: 10px;
}
:host #div-banner_inferior {
  margin-top: 48px;
  margin-bottom: 48px;
}
:host #div-banner_inferior:empty {
  display: none;
}
:host .logo-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
@media (max-width: 768px) {
  :host .logo-wrapper {
    margin-top: 64px;
  }
}
:host .logo-wrapper .stats-scroll {
  margin: 0 calc(16.6% - 18px) 0 calc(49.9% - 18px);
  flex: 0 0 36px;
  background: transparent;
  height: 36px;
  width: 36px;
  outline: none;
  border: none;
}
:host .logo-wrapper .stats-scroll:focus img, :host .logo-wrapper .stats-scroll:hover img {
  background: rgba(255, 255, 255, 0.5);
}
:host .logo-wrapper .stats-scroll img {
  border: 1px solid #787D8B;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 8px;
  cursor: pointer;
}
:host .logo-wrapper .logos {
  flex: 1 1 auto;
  padding-left: 12px;
  text-align: right;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}
:host .logo-wrapper .logos .logo {
  display: inline-block;
  font-size: 10px;
  color: #787D8B;
}
:host .logo-wrapper .logos .logo img {
  vertical-align: middle;
  margin-bottom: 4px;
  margin-left: 8px;
}
:host .logo-wrapper .logos .logo + .logo {
  margin-left: 33px;
}
:host .logo-wrapper .logos .logo.geo {
  text-decoration: none;
}
:host .logo-wrapper .logos .logo.geo img {
  height: 24px;
}
@media (max-width: 768px) {
  :host .logo-wrapper {
    flex-direction: column;
  }
  :host .logo-wrapper .stats-scroll {
    flex: 1 1 100%;
    margin: 0 0 24px 0;
  }
}

@keyframes load {
  0% {
    stroke-dashoffset: 0;
    opacity: 1;
  }
  100% {
    stroke-dashoffset: 1260;
    opacity: 1;
  }
}
@keyframes rotate {
  0% {
    transform: rotateZ(-90deg);
  }
  100% {
    transform: rotateZ(270deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/match/match.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,yBCaS;ADdX;AAGE;EACE,cAAA;EACA,mBAAA;AADJ;AAIM;EACE,iBAAA;EACA,mBAAA;AAFR;AAQE;EACE,gBAAA;AANJ;AAQM;EACE,iBAAA;EACA,WAAA;AANR;AASM;EACE,iBAAA;AAPR;AAYE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;AAWI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cCjCK;EDkCL,mBAAA;EACA,iCAAA;AATN;AAaM;EACE,6BAAA;AAXR;AAgBE;EACE,cAAA;EACA,cAAA;AAdJ;AAiBE;EACE,mBC7DS;ED8DT,mBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,aAAA;AAhBN;AAoBE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAlBJ;AAmBI;EAPF;IAQI,gBAAA;EAhBJ;AACF;AAkBI;EACE,iDAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AAhBN;AAmBQ;EACE,oCAAA;AAjBV;AAqBM;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAnBR;AAsBI;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AApBN;AAsBM;EACE,qBAAA;EACA,eAAA;EACA,cClHG;AD8FX;AAsBQ;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;AApBV;AAsBQ;EACE,iBAAA;AApBV;AAuBQ;EACE,qBAAA;AArBV;AAsBU;EACE,YAAA;AApBZ;AA0BI;EAnEF;IAoEI,sBAAA;EAvBJ;EAyBI;IACE,cAAA;IACA,kBAAA;EAvBN;AACF;;AA6BA;EACE;IACE,oBAAA;IACA,UAAA;EA1BF;EA6BA;IACE,uBAAA;IACA,UAAA;EA3BF;AACF;AA8BA;EACE;IACE,0BAAA;EA5BF;EA+BA;IACE,0BAAA;EA7BF;AACF","sourcesContent":["@import 'theme';\n\n:host {\n  display: block;\n  background-color: $colorN05;\n  //padding-top:32px;\n  app-map {\n    display: block;\n    margin-bottom: 32px;\n\n    ::ng-deep {\n      .teams, .mapFooter {\n        max-width: 1200px;\n        margin: 0 auto 30px;\n      }\n    }\n  }\n\n\n  app-stats {\n    margin-top: 32px;\n    ::ng-deep {\n      .badgesWrapper {\n        max-width: 1200px;\n        width: 100%;\n      }\n\n      .summaryWrapper {\n        max-width: 1200px;\n      }\n    }\n  }\n\n  .loader-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255,255,255,0.5);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    p {\n      font-size: 24px;\n      line-height: 28px;\n      padding: 12px 24px;\n      color: $colorN20;\n      border-radius: 24px;\n      background: transparentize($colorN100, 0.1);\n    }\n\n    &.show {\n      svg, svg path {\n        animation-play-state: running;\n      }\n    }\n  }\n\n  .banner ::ng-deep iframe {\n    display: block;\n    margin: 0 auto;\n  }\n\n  #div-banner_superior {\n    background: $colorAdsBG;\n    margin-bottom: 10px;\n  }\n\n  #div-banner_inferior {\n    margin-top: 48px;\n    margin-bottom: 48px;\n\n    &:empty {\n      display: none;\n    }\n  }\n\n  .logo-wrapper {\n    max-width: 1200px;\n    margin: 0 auto;\n    margin-top: 24px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    @media (max-width: $mobileBreakpoint) {\n      margin-top: 64px;\n    }\n\n    .stats-scroll {\n      margin: 0 calc(16.6% - 18px) 0 calc(33.3% + 16.6% - 18px);\n      flex: 0 0 36px;\n      background: transparent;\n      height: 36px;\n      width: 36px;\n      outline: none;\n      border: none;\n\n      &:focus, &:hover {\n        img {\n          background: transparentize($colorWhite, 0.5);\n        }\n      }\n\n      img {\n        border: 1px solid $colorN50;\n        border-radius: 50%;\n        width: 36px;\n        height: 36px;\n        padding: 8px;\n        cursor: pointer;\n      }\n    }\n    .logos {\n      flex: 1 1 auto;\n      padding-left: 12px;\n      text-align: right;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: flex-end;\n\n      .logo {\n        display: inline-block;\n        font-size: 10px;\n        color: $colorN50;\n\n        img {\n          vertical-align: middle;\n          margin-bottom: 4px;\n          margin-left: 8px;\n        }\n        & + .logo {\n          margin-left: 33px;\n        }\n\n        &.geo {\n          text-decoration: none;\n          img {\n            height: 24px;\n          }\n        }\n      }\n    }\n\n    @media (max-width: $mobileBreakpoint) {\n      flex-direction: column;\n\n      .stats-scroll {\n        flex: 1 1 100%;\n        margin: 0 0 24px 0;\n      }\n    }\n  }\n\n}\n\n@keyframes load {\n  0% {\n    stroke-dashoffset: 0;\n    opacity: 1;\n  }\n\n  100% {\n    stroke-dashoffset: 1260;\n    opacity: 1;\n  }\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotateZ(-90deg);\n  }\n\n  100% {\n    transform: rotateZ(270deg);;\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
